export const buildFormPath = (formId, patientId) => `/patients/${patientId}/forms/${formId}`;
//# sourceMappingURL=formPaths.js.map